import { render, staticRenderFns } from "./POSHeader.vue?vue&type=template&id=1f92bdf0&scoped=true"
import script from "./POSHeader.vue?vue&type=script&lang=js"
export * from "./POSHeader.vue?vue&type=script&lang=js"
import style0 from "./POSHeader.vue?vue&type=style&index=0&id=1f92bdf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f92bdf0",
  null
  
)

export default component.exports